import {IEvaluatorOptions} from "./i-evaluator-options";
import {TS} from "../../type/ts";

/**
 * Evaluates, or attempts to evaluate, a TypeAliasDeclaration
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function evaluateTypeAliasDeclaration(_options: IEvaluatorOptions<TS.TypeAliasDeclaration>): void {
	return;
}
